import instance from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { ApiResponse, BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import { FreeTrialSubscriptionParser } from 'pages/subscribeFreeTrial/models';

const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class PricingSummaryDetailsApi extends BaseApi {
  public static getPricingSummaryDetails = async (payload: any): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.public.subscription.getPriceSummary,
        payload
      );

      if (PricingSummaryDetailsApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return PricingSummaryDetailsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return PricingSummaryDetailsApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return PricingSummaryDetailsApi.errorResponse(message);
        }
      }
      return PricingSummaryDetailsApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static getPublicPricingSummaryDetails = async (payload: any): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.public.subscription.getPublicPriceSummary,
        payload
      );

      if (PricingSummaryDetailsApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return PricingSummaryDetailsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return PricingSummaryDetailsApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          let message = FreeTrialSubscriptionParser.parseError(errors);
          let fieldNameStr = "";

          if(message.toLowerCase().indexOf("promo code") !== -1){
            fieldNameStr = errors[0].fieldName;
          }
          
          return PricingSummaryDetailsApi.errorResponse(message, [], fieldNameStr);
        }
      }
      return PricingSummaryDetailsApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  }; 
  
  public static getSchoolPricingSummaryDetails = async (payload: any): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.public.subscription.getSchoolPriceSummary,
        payload
      );

      if (PricingSummaryDetailsApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return PricingSummaryDetailsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return PricingSummaryDetailsApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return PricingSummaryDetailsApi.errorResponse(message);
        }
      }
      return PricingSummaryDetailsApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };  
};